import type { PostHogConfig } from '@/shared/types/posthog';

const DEFAULT_API_HOST = '/ingest';
const DEFAULT_UI_HOST = 'https://us.posthog.com';

export function getPostHogConfig(): PostHogConfig | null {
  const key = process.env.NEXT_PUBLIC_POSTHOG_KEY?.trim() ?? '';

  if (!key) {
    return null;
  }

  return {
    key,
    apiHost: process.env.NEXT_PUBLIC_POSTHOG_HOST?.trim() || DEFAULT_API_HOST,
    uiHost: process.env.NEXT_PUBLIC_POSTHOG_UI_HOST?.trim() || DEFAULT_UI_HOST,
    environment:
      process.env.NEXT_PUBLIC_POSTHOG_ENV?.trim() || process.env.NODE_ENV || 'development',
  };
}
